function isFilterUsed(filter) {

    const terms = filter.options;

    if (!Array.isArray(terms)) {

        return [];

    }

    const numberOfCheckedTerms = terms.some((term) => term.checked === true);

    return numberOfCheckedTerms;

}

export function filtersToData(filters) {

    if (!Array.isArray(filters)) {

        return [];

    }

    const checkedTerms = filters.filter((filter) => isFilterUsed(filter) > 0);

    const filterArray = checkedTerms.map((filter) => ({
        id: Number(filter.id),
        terms: filter.options
            .filter((term) => term.checked === true)
            .map((term) => Number(term.id)),
    }));

    return filterArray;

}
